import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

export const DialogTrigger = ({ ...props }: ComponentProps<typeof DialogPrimitive.Trigger>) => {
  return <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />;
};
